import styled from "styled-components";
import { useRef, useState } from "react";
import SecondaryButton from "../../../common/components/button/SecondaryButton";
import QRPrintSettingDropdownMenu from "../../../common/components/dropdown/QRPrintSettingDropdownMenu";

const MenuContainer = styled.div`
    position: relative;
    display: flex;
    align-items: center;
`;

export default function QRCodePrintSettingButton({ currentValue, setCurrentValue }) {
    const [isMenuOpen, setIsMenuOpen] = useState(false);

    const buttonRef = useRef(null); // 버튼의 위치를 추적하기 위한 ref

    const toggleMenu = () => {
        setIsMenuOpen((prev) => !prev);
    };

    const handleChange = (newValue) => {
        console.log(`Selected value: ${newValue}`);
        setCurrentValue(newValue);
        setIsMenuOpen(false); // 선택 후 메뉴 닫기
    };

    return (
        <MenuContainer ref={buttonRef}>
            <SecondaryButton icon={"settings_black"} text={"Setting"} onClick={toggleMenu} />
            {isMenuOpen && (
                <QRPrintSettingDropdownMenu
                    initValue={currentValue}
                    setValue={handleChange}
                    onClose={() => setIsMenuOpen(false)}
                    anchorEl={buttonRef.current} // 버튼 엘리먼트를 prop으로 전달
                    placement="bottom-start" // 왼쪽 정렬
                />
            )}
        </MenuContainer>
    );
}
